export enum IllustrationType{
    AnalysisNew = "AnalysisNew",
    TimeManagement = "TimeManagement",
    AnalysisRun = "AnalysisRun",
    ChartClimb = "ChartClimb",
    SovSearch = "SovSearch",
    RegisterAccAgency = "RegisterAccAgency",
    RegisterAccCompany = "RegisterAccCompany",
    RegisterAccFreelance = "RegisterAccFreelance",
    CheckMail = "CheckMail",
    ProjectPlan = "ProjectPlan",
    NewProjectWrong = "NewProjectWrong",
    ProjectNew = "ProjectNew",
}